// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateOrganizationBindingManager, UpdateOrganizationBindingManagerSchema } from 'api/gen/UpdateOrganizationBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOrganizationBindingManagerBaseObject, ValidateOrganizationBindingManagerBaseObjectSchema } from 'api/gen/ValidateOrganizationBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateOrganizationBindingManager'),
  binding: t.union([UpdateOrganizationBindingManagerSchema, t.null]),
});

export const ValidateUpdateOrganizationBindingManagerSchema = excess(t.intersection([ValidateOrganizationBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateOrganizationBindingManager extends t.TypeOf<typeof ValidateUpdateOrganizationBindingManagerSchema> {}
